// eslint-disable-next-line @tseslint/no-shadow
import { Notification } from "./notification.type";

// eslint-disable-next-line @tseslint/typedef
export const PROCESS_STATUS = {
  failed: "failed",
  /** The Evaluation is currently running */
  running: "running",
  /** Was waiting in Queue and then paused there */
  paused: "paused",
  /** Was successfully evaluated but is not yet ready to download  */
  evaluationComplete: "evaluationComplete",
  /** Is completed and ready to download  */
  readyToDownload: "readyToDownload",
  /** Is not actively running yet and still can be pauses  */
  waitingInQueue: "waitingInQueue"
} as const;
export type ProcessStatus = typeof PROCESS_STATUS[keyof typeof PROCESS_STATUS];
// eslint-disable-next-line @tseslint/typedef
export const PROCESS_TYPES = {
  PDF: "PDF"
} as const;
export type ProcessType = typeof PROCESS_TYPES[keyof typeof PROCESS_TYPES];
export interface ProcessStatusDto {
  restart?: boolean | undefined;
  failed?: boolean | undefined;
  inProgress?: boolean | undefined;
  processed?: boolean | undefined;
  paused?: boolean | undefined;
  uploaded?: boolean | undefined;
}
export interface ProcessDto extends ProcessBase, ProcessStatusDto {
  printId: string;
  markedAsSeen: boolean;
}
export interface ProcessBase {
  downloadLink?: string | undefined;
  validUntil?: Date | undefined;
  createdAt?: Date | undefined;
  type: ProcessType;
  name: string;
  contextName: string;
}
export interface Process extends ProcessBase {
  id: string;
  status: ProcessStatus;
}
export interface ProcessNotification extends Notification {
  process: Process;
}
export function parseToProcessStatus (processDtoStatus: ProcessStatusDto): ProcessStatus {
  if (processDtoStatus.failed)
    return PROCESS_STATUS.failed;

  if (processDtoStatus.inProgress)
    return PROCESS_STATUS.running;

  if (processDtoStatus.processed && !processDtoStatus.uploaded)
    return PROCESS_STATUS.evaluationComplete;

  if (processDtoStatus.uploaded)
    return PROCESS_STATUS.readyToDownload;

  if (processDtoStatus.paused)
    return PROCESS_STATUS.paused;

  // Is waiting in queue if process is neither inProgress nor processed
  return PROCESS_STATUS.waitingInQueue;
}
export function parseToProcessStatusDto (processStatus: ProcessStatus): ProcessStatusDto {
  switch (processStatus) {
    case PROCESS_STATUS.failed: {
      return { failed: true };
    }

    case PROCESS_STATUS.running: {
      return { inProgress: true };
    }

    case PROCESS_STATUS.waitingInQueue: {
      return { inProgress: false, processed: false };
    }

    case PROCESS_STATUS.paused: {
      return { paused: true };
    }

    case PROCESS_STATUS.readyToDownload: {
      return { uploaded: true };
    }

    default: {
      return { processed: true };
    }
  }
}
export function parseToProcess (processDto: ProcessDto): Process {
  return {
    ...processDto,
    status: parseToProcessStatus(processDto),
    id: processDto.printId,
    validUntil: processDto.validUntil ? new Date(processDto.validUntil) : undefined,
    createdAt: processDto.createdAt ? new Date(processDto.createdAt) : undefined
  } as Process;
}
export function parseToProcessDto (process: Pick<Process, "id" | "status">): Partial<ProcessDto> {
  return {
    ...parseToProcessStatusDto(process.status),
    printId: process.id
  };
}
export function parseToProcessNotification (processDto: ProcessDto): ProcessNotification {
  return { process: parseToProcess(processDto), isSeen: processDto.markedAsSeen };
}
